import { render, staticRenderFns } from "./VuebaseLayout2.vue?vue&type=template&id=aeed6e02&scoped=true"
import script from "./VuebaseLayout2.vue?vue&type=script&lang=js"
export * from "./VuebaseLayout2.vue?vue&type=script&lang=js"
import style0 from "./VuebaseLayout2.vue?vue&type=style&index=0&id=aeed6e02&prod&lang=css"
import style1 from "./VuebaseLayout2.vue?vue&type=style&index=1&id=aeed6e02&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeed6e02",
  null
  
)

export default component.exports